import React from "react";
import { matchPath } from "react-router-dom";

import { getContext, getContextKey } from "modules/context/api/getContext";
import { ContextProvider } from "modules/context/Providers/ContextProvider";

import { useReactQuery } from "components/RemoteData";
import { WarningNotification } from "components/ErrorBoundary";
import { ChakraText } from "components/ChakraText";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const ContextConfigurationProvider = ({ children }: IProps) => {
  const match = matchPath<{ friendlyUrl: string }>(window.location.pathname, {
    path: "/e-rezerwacja/:friendlyUrl",
  });
  const friendlyUrl = match?.params.friendlyUrl || "default";

  const { data: context } = useReactQuery(getContextKey(), () =>
    getContext(friendlyUrl)
  );

  if (!context) {
    return (
      <WarningNotification>
        <ChakraText fontSize="3xl">Brak konfiguracji</ChakraText>
      </WarningNotification>
    );
  }

  return <ContextProvider data={context}>{children}</ContextProvider>;
};

export { ContextConfigurationProvider };
